import React from 'react';

import withCard from './WithCard';
import Integer from '../../../Types/Components/Integer';

const IntegerCard = (props) => {
  return <Integer {...props} />
}

export default withCard(IntegerCard);